export const ORDER_STATUS_LABELS = {
    new: 'Ожидает оплаты',
    paid: 'Оплачен',
    shipped: 'В пути',
    completed: 'Доставлен',
    canceled: 'Отменён',
    processing: 'В обработке',
};

export const ORDER_STATUS_LABELS_PLURAL = {
    new: 'Ожидают оплаты',
    paid: 'Оплачены',
    shipped: 'В пути',
    completed: 'Доставлены',
    canceled: 'Отменены',
    processing: 'В обработке',
};

export function getOrderStatusLabel(status, {plural = false} = {}) {
    const map = plural ? ORDER_STATUS_LABELS_PLURAL : ORDER_STATUS_LABELS;
    return map[status] || status || '';
}

export const DELIVERY_TYPE_LABELS = {
    store_pickup: 'Самовывоз',
    courier: 'Курьер',
    pvz: 'ПВЗ',
};

export function getDeliveryTypeLabel(deliveryType) {
    return DELIVERY_TYPE_LABELS[deliveryType] || deliveryType || '—';
}
